export default "__VITE_ASSET__e3e6094c__"